const CMS_BASE_URL =
  process.env.REACT_APP_CMS_BASE_URL || window.location.origin + "/cms/api";
// const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL || "";
// const REACT_APP_ENVIRONMENT = process.env || {};
// const ENVIRONMENT = process.env.ENVIRONMENT || "";
export const API_URL =
  process.env.REACT_APP_API_BASE_URL || window.location.origin + "/api";
export const CMS_URL = CMS_BASE_URL
const STRAPI_BASE_URL = process.env.REACT_APP_STRAPI_BASE_URL || "https://agw-test-apps-strapi.ashyisland-c2cc629e.francecentral.azurecontainerapps.io";
const TUTOR_VIDEO_URL = process.env.REACT_APP_TUTOR_VIDEO_URL || "https://www.youtube.com/embed/Tgn1onW7fV8?controls=0";
export const REACT_APP_NEW_THEME = process.env.REACT_APP_NEW_THEME || 'positiverepresentation';
export const API_URLS: {
  FAQ: string;
  REFERENCES: string;
  REFERENCES_FRAMEWORKS: string;
  APP_SETTINGS: string;
  ABOUT: string;
  NAVBAR: string;
  USER_INFO: string;
  TOKEN_INFO: string;
  UPDATE_USER_CONSENT: string;
  APP_LABEL: string;
  STRAPI_BASE_URL: string;
  TUTOR_VIDEO_URL: string;
  CAPTCH_LOAD: string;
  CAPTCH_VERIFY:string;
  GENERATE_PASSWORD:string;
  CHANGE_PASSWORD:string;
  EXTERNAL_LOGIN:string;

} = {
  REFERENCES_FRAMEWORKS: CMS_BASE_URL + "/reference-frameworkS",  
  FAQ: CMS_BASE_URL + "/faq-pages",
  REFERENCES: CMS_BASE_URL + "/rules-set-pages",
  APP_SETTINGS: CMS_BASE_URL + "/frontend-types",
  NAVBAR: CMS_BASE_URL + "/navbar",
  ABOUT: CMS_BASE_URL + "/about-pages",
  USER_INFO: API_URL + "/users/me",
  TOKEN_INFO: API_URL + "/users/token",
  UPDATE_USER_CONSENT: API_URL + "/user/update_consent",
  APP_LABEL: CMS_BASE_URL + "/application-labels",
  STRAPI_BASE_URL: STRAPI_BASE_URL,
  TUTOR_VIDEO_URL: TUTOR_VIDEO_URL,
  CAPTCH_LOAD: API_URL + "/captcha",
  CAPTCH_VERIFY: API_URL + "/user/send-otp",
  GENERATE_PASSWORD: API_URL + "/user/update-password",
  CHANGE_PASSWORD: API_URL + "/user/change-password",
  EXTERNAL_LOGIN: API_URL + "/std/login",
};

export const BEARER_TOKENS: {
  CMS: string;
} = {
  CMS:
    process.env.REACT_APP_CMS_BEARER_TOKEN ||
    "0c98871a8dd541b499b4221a0270154b7cf15e84fc6305d07293791aca165074349eb466ed93cbf1af1b43f36b0438b6492a6f8d2d505b97a674dcdaa349bc59efb07fbb8eae24c704e746ea478c4ad3fb181851279a0b093cf944ed8f9ed961a372c9673a29e2e25b854534e5fbb60c147eaa0432134dd39b1b228f633d3430",
};
// diversity and inclusion / responsiblity lifestyle
export const COMPLIANCE_COLOR_CODES: Record<"-1" | "0" | "1" | "2" | "3", string> = {
  "-1": "#D3D7D9", // Non Applicable
  "0": "#F84241",  // Non conform
  "1": "#15CB4A",  // Conform
  "2": "#FFC400",  // Verification & Sources
  "3": "#A3CDED", // Neutral
};

// aarp human being
export const VOLUNTARY_COLOR_CODES = {
  "-1": "D3D7D9", // Non Applicable
  "1": "#15CB4A", // Good Enough
  "2": "#FFC400", // Could be better
}

export const SHOW_TOGGLE_DETAILS = {
  "compliance" : [1,-1],
  "publicis_positive_representations" : [-1],
}